module.exports = __webpack_public_path__ + "static/media/GWEicon.097330e5.png";